import { IStandardAPIResponse } from "../vm";
import jwt_decode from "jwt-decode";
import environment from "environment";
import { ROUTES } from "../definitions/constant/routes"; // Import ROUTES
const tokenKey = "jhp_token";


export const httpCustomUrlClient = async (url: string, type: string, obj: any = undefined
) => {
  try {
    type = type.toUpperCase();
    if (type.toLowerCase() === "get" && obj) {
      var params = Object.keys(obj)
        .map(function (key) {
          return key + "=" + obj[key];
        })
        .join("&");
      url += "?" + params;
      obj = undefined;
    }
    await fetch(url, {
      method: type.toUpperCase(),
      body: obj,
    });
    return null;
  } catch (error) {
    console.group(`Custom API ${type} Error`);
    console.error(error);
    console.groupEnd();
    throw error;
  }
};


export const removeNulls = (obj: any) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === "object") {
      removeNulls(obj[key]);
    } else if (obj[key] === null) {
      delete obj[key];
    }
  });
  return obj;
};

export const getToken = () => {
  return localStorage.getItem(tokenKey);
};

export const getFullName = (data: {
  firstName: string;
  middleName?: string;
  lastName?: string;
}) => {
  let name = data.firstName;
  if (data.middleName) {
    name = name + " " + data.middleName;
  }
  if (data.lastName) {
    name = name + " " + data.lastName;
  }
  return name;
};


export const getUserName = () => {
  let token: any = localStorage.getItem(tokenKey);
  if (token) {
    var decoded = jwt_decode(token);
    //@ts-ignore
    let { name } = decoded;
    if (name && name !== undefined) {
      console.log(name);
      return name;
    }
  }
  return undefined;
};

export const getRole = () => {
  let token: any = localStorage.getItem(tokenKey);
  if (token) {
    var decoded: any = jwt_decode(token);
    let { role } = decoded;
    console.log("role", role);
    return role;
  }
  return undefined;
};

export const getUser = () => {
  let token: any = localStorage.getItem(tokenKey);
  if (token) {
    const decoded: any = jwt_decode(token);
    const { role } = decoded;
    if (role === "employee") {
      return true;
    } else {
      return false;
    }
  }
  return false;
};

export const findUserId = () => {
  let token: any = localStorage.getItem(tokenKey);
  if (token) {
    var decoded = jwt_decode(token);
    //@ts-ignore
    let { user_id } = decoded;
    return user_id
  }
  return undefined;
}

export async function httpClient<T>(
  url: string,
  type: string,
  obj: any = undefined,
  isFormData: boolean = false // New parameter to handle FormData
): Promise<IStandardAPIResponse<T>> {
  try {
    type = type.toUpperCase();
    if (type.toLowerCase() === "get" && obj) {
      const params = Object.keys(obj)
        .map(function (key) {
          if (typeof obj[key] === "object" && obj[key].length !== undefined) {
            let a = obj[key].map((e: any) => {
              return key + "=" + e;
            });
            return a.join("&");
          } else {
            return key + "=" + obj[key];
          }
        })
        .join("&");
      url += "?" + params;
      obj = undefined;
    }
    const headers: HeadersInit = {
      "encryption": "false",
      token: getToken() || ""
    };

    let body: BodyInit | null = null;

    if (isFormData) {
      body = obj; // Send FormData directly
      // Do not set Content-Type for FormData, browser will set it automatically
    } else {
      body = JSON.stringify(obj);
      headers["Content-Type"] = "application/json";
    }

    const res = await fetch(environment.api.base + "/" + url, {
      method: type.toUpperCase(),
      body: body,
      headers: headers,
    });

    if (res.status === 401) {
      removeToken();
      window.location.href = ROUTES.login; // Redirect to login page
      return Promise.reject(new Error("Unauthorized: Invalid or expired token."));
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.group(`API ${type} Error`);
    console.error(error);
    console.groupEnd();
    throw error;
  }
}

export const setToken = (token: string) => {
  localStorage.setItem(tokenKey, token);
};
export const removeToken = () => {
  localStorage.removeItem(tokenKey);
};

export const processUrl = (url: string) => {
  const s3Domain = "https://jamanentterprise.s3.ap-south-1.amazonaws.com";
  // Check if the URL already contains the S3 domain
  if (url?.includes(s3Domain)) {
    return url;
  } else {
    return `${s3Domain}/${url}`;
  }
}


export const isNotAdmin = () => {
  let token: any = localStorage.getItem(tokenKey)
  if (token) {
    var decoded = jwt_decode(token);
    //@ts-ignore
    let { role } = decoded;
    return role
  }
  return undefined;
}


export const isSuperAdmin = () => {
  let token: any = localStorage.getItem("access_token");
  if (token) {
    var decoded = jwt_decode(token);
    //@ts-ignore
    const { role } = decoded;
    return role === "superadmin" ? true : false
  }
  return false;
};

export const getUserEmail = () => {
  const token: any = localStorage.getItem(tokenKey);

  if (token) {
    const decoded = jwt_decode(token);
    //@ts-ignore
    const { email } = decoded;
    return email
  }
  return undefined;
};


export const getShortName = () => {
  const token: any = localStorage.getItem(tokenKey);
  if (token) {
    const decoded = jwt_decode(token);
    //@ts-ignore
    const { name } = decoded;
    if (name && name !== undefined) {
      return name.slice(0, 6);
    }
  }
}

export const getUserId = () => {
  let token: any = localStorage.getItem(tokenKey);
  if (token) {
    var decoded = jwt_decode(token);
    //@ts-ignore
    let { user_id } = decoded;
    return user_id
  }
  return undefined;
}

export const parseJwt = (tokenParsed?: string) => {
  let token;
  if (!tokenParsed) {
    token = getToken();
  } else {
    token = tokenParsed;
  }
  if (token) {
    try {
      var base64Url = token.split(".")[1];
      if (!base64Url) {
        console.warn("Invalid JWT format: missing base64Url part.");
        return undefined; // Token is not a valid JWT format
      }
      var base64 = base64Url.replace("-", "+").replace("_", "/");
      return JSON.parse(window.atob(base64));
    } catch (error) {
      console.error("Error parsing JWT token:", error);
      return undefined;
    }
  }
  return undefined;
};

export const isTokenExpired = () => {
  const token = getToken();

  if (token) {
    const user = parseJwt(token);
    const cur_time = new Date().getTime() / 1000;

    if (user && user.exp && cur_time < user.exp) {
      return false;
    }
    return true;
  }

  return true;
};


export const getUserInfo = () => {
  const userInfo: any = localStorage.getItem("jhpuser");
  return userInfo ? JSON.parse(userInfo) : null;
};

export const handleErrorResp = (err: any): IStandardAPIResponse<any> => {
  console.error(err);
  return {
    success: false,
    data: err,
    message: "",
  };
};


